// base
import React, { Component } from "react";

// components
import {
  Layout,
  Search,
  PageState,
  ContentsBox,
  IsLoadingLayout,
  ContractOverview,
  ContractProfileSummary,
  ContractTransfers,
  ContractAbiView,
  Pager,
} from "../../components";
import { connect } from "react-redux";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import ReactTooltip from "react-tooltip";

// assets
import "./contract.scss";
import defaultSymbol from "../../assets/images/common/default_symbol.png";

// api
import { contractDetail, contractInTransactions } from "../../../api";

class Contract extends Component {
  constructor(props) {
    super(props);
    this.state = this.initState();
    this.loadPage(props.match.params.address);
  }

  initState = () => {
    return {
      contract: null,
      transactions: null,
      transactionCnt: 0,
      pageNum: 1,
      pages: 1,
      abi: null,
      abiViewData: [],
      selectTab: 0,
    };
  };

  componentDidUpdate(prevProps) {
    const { address } = this.props.match.params;
    if (address !== prevProps.match.params.address) {
      this.setState(this.initState());
      this.loadPage(address);
    }
    ReactTooltip.rebuild();
  }

  getContract = (address) => {
    contractDetail(address)
      .then((res) => {
        if (res.data) {
          let contract = res.data;
          let abi = contract.abi ? JSON.parse(contract.abi) : null;
          let abiViewData = abi
            ? abi.filter((data) => {
                return data.stateMutability && data.stateMutability === "view";
              })
            : [];

          this.setState({ contract, abi, abiViewData });
        } else {
          this.props.history.push(`/`);
        }
      })
      .catch((err) => {
        this.props.history.push(`/`);
        console.error(err);
      });
  };

  getTransactions = (address, pageNum) => {
    contractInTransactions(address, pageNum)
      .then((res) => {
        if (res.data) {
          this.setState({
            transactions: res.data.list,
            transactionCnt: res.data.total,
            pageNum: res.data.pageNum,
            pages: res.data.pages,
          });
        } else {
          this.setState({ transactions: [] });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ transactions: [] });
      });
  };

  loadPage = (address) => {
    this.getContract(address);
    this.getTransactions(address, 1);
  };

  movePage = (action) => {
    const { address } = this.props.match.params;
    const { pageNum, pages } = this.state;

    if (action === "next" && pageNum < pages) {
      this.getTransactions(address, pageNum + 1);
    } else if (action === "prv" && pageNum > 1) {
      this.getTransactions(address, pageNum - 1);
    }
  };

  changeTab = (index) => {
    this.setState({ selectTab: index });
  };

  render() {
    const { address } = this.props.match.params;
    const {
      contract,
      transactions,
      transactionCnt,
      pageNum,
      pages,
      abi,
      abiViewData,
      selectedTab,
    } = this.state;

    return (
      <Layout>
        <main className="contract">
          <div className="l-wrapper">
            <div className="page_upper">
              <Search />
              <PageState
                pageName={
                  contract
                    ? contract.tokenType
                      ? "Token"
                      : "Contract"
                    : "Token"
                }
                hash={address}
              />
            </div>
            {contract ? (
              <div className="contract_contents">
                <div className="contract_content">
                  <ContentsBox style={{ padding: "20px 40px" }}>
                    <div className="contract_info">
                      <img
                        className="contract_icon"
                        alt="icon"
                        src={contract.icon ? contract.icon : defaultSymbol}
                        onError={(e) => (e.target.src = defaultSymbol)}
                      />
                      <div className="contract_desc">
                        <span className="contract_name">{contract.name}</span>
                        <span className="contract_symbol">
                          {contract.symbol}
                        </span>
                      </div>
                    </div>
                  </ContentsBox>
                </div>
                <div className="contract_content">
                  <ContentsBox title="Overview">
                    <ContractOverview
                      contract={contract}
                      transactionCnt={transactionCnt}
                    />
                  </ContentsBox>
                </div>
                <div className="contract_content">
                  <ContentsBox title="Profile Summary">
                    <ContractProfileSummary contract={contract} />
                  </ContentsBox>
                </div>
                <div className="contract_content">
                  <ContentsBox>
                    <Tabs selectedIndex={selectedTab} onSelect={this.changeTab}>
                      <TabList>
                        <Tab>Transactions</Tab>
                        <Tab>Contract</Tab>
                      </TabList>
                      <TabPanel>
                        {transactions ? (
                          transactions.length > 0 && (
                            <>
                              <ContractTransfers
                                abi={abi}
                                transactions={transactions}
                              />
                              <div className="contract_pager">
                                <Pager
                                  currentPage={pageNum}
                                  totalnum={pages}
                                  movepage={this.movePage}
                                />
                              </div>
                            </>
                          )
                        ) : (
                          <IsLoadingLayout isLoading={true} />
                        )}
                      </TabPanel>
                      <TabPanel>
                        <ContractAbiView
                          address={address}
                          creator={contract.creator}
                          abiViewData={abiViewData}
                        />
                      </TabPanel>
                    </Tabs>
                  </ContentsBox>
                </div>
                <ReactTooltip />
              </div>
            ) : (
              <ContentsBox title="Overview">
                <IsLoadingLayout isLoading={true} />
              </ContentsBox>
            )}
          </div>
        </main>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  // return {
  //   network: state.appState.network,
  // };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Contract);
